import {useCustomQuery} from '@salesforce/commerce-sdk-react'

const useSitePreference = (ids, queryOptions) => {
    return useCustomQuery(
        {
            options: {
                method: 'GET',
                customApiPathParameters: {
                    apiName: 'get-custom-preference',
                    apiVersion: 'v1',
                    endpointPath: 'getCustomPreference'
                },
                parameters: {
                    c_customPreferenceIDs: ids
                }
            }
        },
        queryOptions
    )
}

export default useSitePreference
